import { Box, Grid, Typography } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { TrackedCreatorsContext } from "contexts/TrackedCreators";
import { useContext } from "react";

import Collection from "./Collection";
import styles from "./styles";

export default function TrackedCreatorSideBar() {
  const { setDiscoverTab } = useContext(DiscoverViewContext);
  const { trackedCreatorSideBar, setTrackedCreatorSideBar } = useContext(
    TrackedCreatorsContext,
  );

  const closeDialog = () => {
    setTrackedCreatorSideBar(null);
    setDiscoverTab(null);
  };

  return (
    <>
      <Box>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={styles.header}
        >
          <Grid container item xs={9} alignItems="center">
            <Typography variant="h6" component="div" sx={{ fontSize: 14 }}>
              @
              {
                trackedCreatorSideBar?.trackedCreator.socialMediaAccount
                  .username
              }
            </Typography>
          </Grid>

          <Grid container item xs justifyContent="flex-end">
            <Box
              component="button"
              onClick={closeDialog}
              sx={{
                ...styles.close,
                background: "none",
                border: "none",
                cursor: "pointer",
                p: 1,
              }}
            >
              <Box component="i" className="fa-regular fa-xmark" />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {trackedCreatorSideBar && (
            <Collection trackedCreatorWrapper={trackedCreatorSideBar} />
          )}
        </Grid>
      </Box>
    </>
  );
}
